/* ==========================================================================
   Literals > Autocomplete
   ========================================================================== */

const getCommonLiterals = require('../base/prototype');

const autocompleteLiterals = {
    es: {
        bus: 'bus',
        airport: 'aeropuerto',
        airports: 'aeropuertos',
        island: 'isla',
        islands: 'islas',
        zone: 'zona',
        zones: 'zonas',
        station: 'estación',
        stations: 'estaciones',
        hotel: 'hotel',
        hotels: 'hoteles',
        city: 'ciudad',
        cities: 'ciudades',
        pdi: 'pdi',
        port: 'puerto',
        ports: 'puertos',
        flightCompanies: 'compañía aérea'
    },
    pt: {
        bus: 'autocarro',
        airport: 'aeroporto',
        airports: 'aeroportos',
        island: 'ilha',
        islands: 'ilhas',
        zone: 'zona',
        zones: 'zonas',
        station: 'estação',
        stations: 'estâncias',
        hotel: 'hotel',
        hotels: 'hotéis',
        city: 'cidade',
        cities: 'cidades',
        pdi: 'pdi',
        port: 'porto',
        ports: 'portos',
        flightCompanies: 'flight_company'
    },
    it: {
        bus: 'autobus',
        airport: 'aeroporto',
        airports: 'aeroporti',
        island: 'isola',
        islands: 'isole',
        zone: 'zona',
        zones: 'zone',
        station: 'stazione',
        stations: 'stazioni',
        hotel: 'hotel',
        hotels: 'hotel',
        city: 'città',
        cities: 'città',
        pdi: 'pdi',
        port: 'porto',
        ports: 'porti',
        flightCompanies: 'flight_company'
    },
    de: {
        bus: 'bus',
        airport: 'flughafen',
        airports: 'flughäfen',
        island: 'insel',
        islands: 'inseln',
        zone: 'reiseziel',
        zones: 'zielgebiete',
        station: 'station',
        stations: 'stationen',
        hotel: 'hotel',
        hotels: 'hotels',
        city: 'stadte',
        cities: 'städte',
        pdi: 'pdi',
        port: 'hafen',
        ports: 'häfen',
        flightCompanies: 'flight_company'
    },
    fr: {
        bus: 'bus',
        airport: 'aéroport',
        airports: 'aéroports',
        island: 'île',
        islands: 'îles',
        zone: 'zone',
        zones: 'zones',
        station: 'station',
        stations: 'stations',
        hotel: 'hôtel',
        hotels: 'hôtels',
        city: 'ville',
        cities: 'villes',
        pdi: 'pdi',
        port: 'port',
        ports: 'ports',
        flightCompanies: 'flight_company'
    },
    br: {
        bus: 'ônibus',
        airport: 'aeroporto',
        airports: 'aeroportos',
        island: 'ilha',
        islands: 'ilhas',
        zone: 'zona',
        zones: 'zonas',
        station: 'estação',
        stations: 'estâncias',
        hotel: 'hotel',
        hotels: 'hotéis',
        city: 'cidade',
        cities: 'cidades',
        pdi: 'pdi',
        port: 'porto',
        ports: 'portos',
        flightCompanies: 'flight_company'
    },
    en: {
        bus: 'bus',
        airport: 'airport',
        airports: 'airports',
        island: 'island',
        islands: 'islands',
        zone: 'zone',
        zones: 'zones',
        station: 'station',
        stations: 'stations',
        hotel: 'hotel',
        hotels: 'hotels',
        city: 'city',
        cities: 'cities',
        pdi: 'poi',
        port: 'port',
        ports: 'ports',
        flightCompanies: 'flight_company'
    },
    fi: {
        bus: 'bussi',
        airport: 'lentokenttä',
        airports: 'lentokentille',
        island: 'saari',
        islands: 'saaret ',
        zone: 'vyöhyke',
        zones: 'alueet',
        station: 'kausi',
        stations: 'asemat',
        hotel: 'hotelli',
        hotels: 'hotellit',
        city: 'kaupunki',
        cities: 'kaupungit',
        pdi: '',
        port: 'portti',
        ports: 'satamat',
        flightCompanies: 'flight_company'
    },
    mx: {
        bus: 'bus',
        airport: 'aeropuerto',
        airports: 'aeropuertos',
        island: 'isla',
        islands: 'islas',
        zone: 'zona',
        zones: 'zonas',
        station: 'estación',
        stations: 'estaciones',
        hotel: 'hotel',
        hotels: 'hoteles',
        city: 'ciudad',
        cities: 'ciudades',
        pdi: 'pdi',
        port: 'puerto',
        ports: 'puertos',
        flightCompanies: 'flight_company'
    },
    ru: {
        bus: 'bus',
        airport: 'aэропорт',
        airports: 'аэропорты',
        island: 'oстрова',
        islands: 'oстрова',
        zone: 'Зона',
        zones: 'Зоны',
        station: 'станцию',
        stations: 'станции',
        hotel: 'отель',
        hotels: 'oтели',
        city: 'город',
        cities: 'Города',
        pdi: 'Достопримечательности',
        port: 'порт',
        ports: 'Порты',
        flightCompanies: 'flight_company'
    }
};

module.exports = function fn(language = 'es') {
    const commonLiterals = getCommonLiterals(language);

    return { ...commonLiterals, ...(autocompleteLiterals[language] || {}) };
};
